import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import {
  collection,
  getDocs,
  db,
  query,
  where,
  setDoc,
  doc,
  limit,
} from '../../FirebaseInit';


const initialState = {
  review: [],
  isEndReached: false,
  isLoading: false,
  isError: false,
  error: ''
};
export const loadReview = createAsyncThunk('review/loadReview',
  (id) => {
    console.log(id);
    return new Promise(async (res, rej) => {
      try {
        const docRef = collection(db, 'review');
        const docs = query(docRef, where('id', "==", id),limit(20));
        const querySnapShot = await getDocs(docs);
        let list = [];
        querySnapShot.forEach(doc => {
          list.push({...doc.data()});
          console.log(doc.data());
        });
        console.log(list);
        res(list);
      } catch (e) {
        console.log(e.message);
        rej(e.message);
      }
    })
  });

export const addReview = createAsyncThunk('review/addReview',
  ({id,comment,userRef}) => {
    console.log(id);
    return new Promise(async (res, rej) => {
      try {
        await setDoc(doc(collection(db, 'review')), {
          id: id,
          review: comment,
          user_name: userRef.displayName,
        }).catch(e => {
          console.log(e.message);
        })
        res({id,review:comment,user_name:userRef.displayName});
      } catch (e) {
        console.log(e.message);
        rej(e.message);
      }
    });
  });

export const reviewSlice = createSlice({
  name: "actor",
  initialState,
  extraReducers: (builder) => {

    //addActor
    builder.addCase(addReview.pending, (state, _) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
    });
    builder.addCase(addReview.fulfilled, (state, {payload}) => {
      state.review = [...state.review, payload];
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(addReview.rejected, (state, {payload}) => {
      state.isLoading = false;
      state.isError = true;
      state.error = payload;
    });
    //loadActor
    builder.addCase(loadReview.pending, (state, _) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
    });
    builder.addCase(loadReview.fulfilled, (state, {payload}) => {
      state.review = payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(loadReview.rejected, (state, {payload}) => {
      state.isLoading = false;
      state.isError = true;
      state.error = payload;
    });
  }
});

export const reviewReducer = reviewSlice.reducer;